import { Module } from "vuex";
import state, { PermisosState } from "./state";
import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

const permisosModule: Module<PermisosState, any> = {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};

export default permisosModule;